@if (!appSetting.isMobile) {
	@if (!notificationReady) {
		<i class="nav-link jmRoundCenterBackground" style="color: #7F8C8D; background-color: #ecf0f1; margin-right: 15px;"></i>
	}
	@if (notificationReady) {
		<section ngbDropdown>
			<i ngbDropdownToggle class="nav-link icnBell jmRoundCenterBackground" role="button" style="color:#7F8C8D; background-color:#ecf0f1; margin-right:15px; display:inline-block;">
				@if (notifications.length > 0) {
					<span style="border-radius:100%; color:#fff; background-color:#FAD59A; padding:5px; font-size:10px; position:absolute; top:0; width: 20px; height:20px; line-height:1;">{{notifications.length}}</span>
				}
			</i>
			<div ngbDropdownMenu style="width:400px; left:-330px;">
				<div class="jmArrowUp"></div>
				<ul class="w-100" style="padding:10px; max-height:300px; overflow-x:hidden; overflow-y:auto;">
					@if (notifications.length === 0) {
						<li ngbDropdownItem style="text-align:center; height:100%; border:none;">No New Notification</li>
					}
					@for (n of notifications; track $index) {
						<li ngbDropdownItem style="background-color:#eee; padding:5px; margin-top:10px; white-space:normal;">
							<table style="width:100%">
							<colgroup><col style="width:25px" /><col /><col style="width:62px" /></colgroup>
							<tbody>
								<tr>
									<td class="text-center text-white p-2" style="line-height: 2;">
										@switch(n.NotificationId) {
											@case("0") {<div class="rounded-circle" style="width: 30px; height: 30px; background-color: #2692FF; ">P</div>} <!--light blue -->
											@case("1") {<div class="rounded-circle" style="width: 30px; height: 30px; background-color: #26FF87; ">I</div>} <!-- green  -->
											@case("2") {<div class="rounded-circle" style="width: 30px; height: 30px; background-color: #8019FF; ">S</div>} <!-- purple  -->
											@case("6") {<div class="rounded-circle" style="width: 30px; height: 30px; background-color: #FF5132; ">C</div>} <!-- red  -->
											@case("7") {<div class="rounded-circle" style="width: 30px; height: 30px; background-color: #0026FF; ">J</div>} <!--blue  -->
											@case("8") {<div class="rounded-circle" style="width: 30px; height: 30px; background-color: #0026FF; ">J</div>} <!--blue  -->
											@case("9") {<div class="rounded-circle" style="width: 30px; height: 30px; background-color: #0026FF; ">J</div>} <!--blue  -->
											@case("10") {<div class="rounded-circle" style="width: 30px; height: 30px; background-color: #0026FF; ">J</div>} <!--blue  -->
											@case("11") {<div class="rounded-circle" style="width: 30px; height: 30px; background-color: #FFD596; ">R</div>} <!-- yellow -->
											@default {<div class="rounded-circle" style="width: 30px; height: 30px; background-color: #78BEEC;">&nbsp;</div>}
										}
									</td>
									@if (n.Type === 'View') {
										<td style="padding:5px;">
											<div [innerHTML]="n.Notification" (click)="viewNotification(n)" class="text-info" role="button"></div>
											@if(n.NotificationId == '7' || n.NotificationId == '8' || n.NotificationId == '9'){
												<div><span class="d-inline-block rounded-circle small me-2" style="background-color: #000; width: 5px;height: 5px;vertical-align: middle;">&nbsp;</span>{{n.Age}}</div>
											}
										</td>
										<td style="padding:5px;"><a href="javascript:void(0);" class="text-info" (click)="dismissNotification(n)">Dismiss</a></td>
									}
									@if (n.Type != 'View') {
										<td style="padding:5px;">
											<div [innerHTML]="n.Notification"></div>
											@if(n.NotificationId == '6'){
											<div><span class="d-inline-block rounded-circle small me-2" style="background-color: #000; width: 5px;height: 5px;vertical-align: middle;">&nbsp;</span>{{n.Age}}</div>
											}
										</td>
										<td style="padding:5px;"><a href="javascript:void(0);" class="text-info" (click)="handleNotification(n)">{{n.Type}}</a></td>
									}
								</tr>
							</tbody>
							</table>
						</li>
					}
				</ul>
			</div>
		</section>
	}
}
@if (appSetting.isMobile) {
	@if (notifications.length > 0) {
		<section ngbDropdown [autoClose]="'outside'" style="display:inline-block; margin-right:15px; position:unset;">
			@if (notificationReady) {
				<i ngbDropdownToggle class="icnBell jmRoundCenterBackground" role="button" style="color: #7F8C8D; background-color: #ecf0f1; position: relative; display: inline-block;">
					<span style="border-radius:100%; color:#fff; background-color:#FAD59A; padding:5px; font-size:10px; position:absolute; top:0px; width: 20px; height:20px; line-height:1;">{{notifications.length}}</span>
				</i>
			}
			<div ngbDropdownMenu style="margin:0px; color:#000; padding:0px;">
				<ul class="w-100" style="padding:10px; max-height:300px; overflow-x:hidden; overflow-y:auto;">
				@for (n of notifications; track n) {
					<li ngbDropdownItem style="background-color:#eee; padding:5px; margin-top:10px;">
						<table style="width:100%; white-space:normal;">
							<colgroup><col style="width:25px" /><col /><col style="width:62px" /></colgroup>
							<tbody>
								<tr>
									<td style="padding:5px;"><div style="display:inline-block;border-radius:100%; background-color:#78BEEC; width:20px; height:20px;">&nbsp;</div></td>
									<td style="padding:5px;">
										<span [innerHTML]="n.Notification"></span>
										@if (n.NotificationId == '6' || n.NotificationId == '7' || n.NotificationId == '8') {
											<span [innerHTML]="n.Age" style="margin-left:5px;"></span>
										}
									</td>
									<td style="padding:5px;"><a href="javascript:void(0);" class="text-info" (click)="handleNotification(n)" style="text-transform: uppercase;">{{n.Type}}</a></td>
								</tr>
							</tbody>
						</table>
					</li>
				}
				</ul>
			</div>
		</section>
	}
}
